export default __webpack_public_path__ + "static/media/canadaLandingBackground.c0b2fc77.jpg";